import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as Company from './Company';

export type V = {
  '@id': string;
  '@type': 'CompanyProjectSummary';
  company: Company.BaseView;
  numOpenTickets: number;
  maintenanceMinutesLogged: number | null;
  projects: Array<{
    '@id': string;
    '@type': 'ProjectSummary';
    project: {
      '@id': string;
      '@type': 'Project';
      id: string;
      name: string;
      createdAt: string;
      archivedAt: string | null;
    };
    serviceOrders: Array<{
      '@id': string;
      '@type': 'ServiceOrder';
      id: string;
      stages: Array<{
        '@id': string;
        '@type': 'ServiceOrderStage';
        id: string;
        name: string;
        startDate: string | null;
        estimatedFinishDate: string | null;
        finishDate: string | null;
      }>;
      name: string;
      referenceNumber: string | null;
      budget: number | null;
      dayLimit: string | null;
      totalMinutesLogged: number;
      finishDate: string | null;
    }>;
  }>;
  serviceOrders: Array<{
    '@id': string;
    '@type': 'ServiceOrder';
    id: string;
    stages: Array<{
      '@id': string;
      '@type': 'ServiceOrderStage';
      id: string;
      name: string;
      startDate: string | null;
      estimatedFinishDate: string | null;
      finishDate: string | null;
    }>;
    name: string;
    referenceNumber: string | null;
    budget: number | null;
    dayLimit: string | null;
    totalMinutesLogged: number;
    finishDate: string | null;
  }>;
};

export function useReadCollectionProjectSummaryAsAgency(options?: ReadConfig) {
  return useApiRead<HydraCollection<V>>(
    `/companies/project-summary-as-agency`,
    options
  );
}
